import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import Dialog from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import Confirm from '@anm/components/notification/Confirm';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

export type HaveNotHostedAlertProps = {
  editorUrl: string;
  onClose?: () => void;
};

const haveNotHostedText = 'Please publish your video before adjusting video settings.';

const haveNotHostedTitle = 'This video should be published first';

const HaveNotHostedAlert: FC<HaveNotHostedAlertProps> = ({ editorUrl, onClose = noop }) => {
  return !isMobileOrIPad() ? (
    <Dialog onModalClose={onClose} onSubmit={() => window.open(editorUrl)}>
      <Confirm
        title={haveNotHostedTitle}
        buttonLeft={{
          isPending: false,
          color: 'red',
          text: 'Cancel',
          size: 'upper-medium' as ButtonSize,
          variant: 'blue-heavy-border' as ButtonVariants
        }}
        buttonRight={{
          isPending: false,
          href: editorUrl,
          text: 'Go to Editor and publish',
          size: 'upper-medium' as ButtonSize,
          variant: 'light-blue' as ButtonVariants
        }}
        onLeftButtonClick={onClose}
        onRightButtonClick={noop}
      >
        {haveNotHostedText}
      </Confirm>
    </Dialog>
  ) : (
    <Dialog onModalClose={onClose} onSubmit={onClose}>
      <AlertBlock
        title={haveNotHostedTitle}
        button={{
          text: 'Edit on desktop and publish',
          size: 'large',
          variant: 'light-blue'
        }}
        onButtonClick={onClose}
      >
        {haveNotHostedText}
      </AlertBlock>
    </Dialog>
  );
};

export default HaveNotHostedAlert;
